import { Component, Prop, Vue } from 'vue-property-decorator';
import { dropMenuProject } from '@/types/dropMenu';
import style from '@/assets/styles/dropmenu.module.less';
@Component
export default class CommonDropMenuOverlay extends Vue {
  // 传递的是展示的数组
  @Prop() private list!: dropMenuProject[];
  @Prop() private unActive!: () => void;
  @Prop() private menuClick!: any;
  @Prop() private selected!: string;
  @Prop() private arrowPosition!: { left: string; top: string };
  @Prop() private position!: { left: string; right: string; top: string };
  // 设置当前被激活的索引，同时
  handleMenuClick(index: number) {
    this.$emit('tab-click', index);
  }
  isActive(item: dropMenuProject) {
    return { color: item.label === this.selected ? '#FF2436' : '' };
  }
  selectItem(item: dropMenuProject) {
    return () => {
      if (item.stat) {
        // 如果有埋点选中就发送
        window.hxmClickStat(item.stat);
      }
      this.menuClick(item);
      this.close();
    };
  }
  show() {
    document.body.style.setProperty('overflow', 'hidden');
  }
  close() {
    document.body.style.setProperty('overflow', '');
    this.unActive();
    this.$nextTick(() => {
      this.$el.parentNode?.removeChild(this.$el);
    });
  }
  // eslint-disable-next-line no-unused-vars
  render(h) {
    return (
      <div class={style['com-dmoverlay']} onClick={this.close}>
        <div class={style['com-dmoverlay-arrow']} style={this.arrowPosition}></div>
        <div class={style['com-dmoverlay-list']} style={this.position}>
          {this.list.map(item => (
            <div
              class={style['com-dmoverlay-item']}
              style={this.isActive(item)}
              onClick={this.selectItem(item)}
            >
              {item.label}
            </div>
          ))}
        </div>
      </div>
    );
  }
  mounted() {
    this.show();
  }
}
